import { GetPositionArgs, Position } from "../../../hooks/useRelativePosition";

export function constrainHorizontalAlignPosition(
  position: Position | null,
  {
    align,
    alignOffset,
    anchorRef,
    contentRef,
    viewportMargin,
  }: Omit<GetPositionArgs, "offset" | "side">,
) {
  if (!position) return null;
  const viewportWidth = window.innerWidth;
  const contentWidth = contentRef.current?.offsetWidth || 0;

  if (align === "end" && position.left < 0) {
    return { ...position, left: viewportMargin };
  }

  if (align === "start" && position.left + contentWidth > viewportWidth) {
    return { ...position, left: viewportWidth - contentWidth - viewportMargin };
  }

  if (align === "center") {
    const targetRect = anchorRef.current?.getBoundingClientRect();
    if (!targetRect) return position;
    const centeredLeft =
      targetRect.left + (targetRect.width - contentWidth) / 2 + alignOffset;
    if (centeredLeft < 0) {
      return { ...position, left: viewportMargin };
    }
    if (centeredLeft + contentWidth > viewportWidth) {
      return {
        ...position,
        left: viewportWidth - contentWidth - viewportMargin,
      };
    }
    return { ...position, left: centeredLeft };
  }

  return position;
}

export function constrainVerticalAlignPosition(
  position: Position | null,
  {
    align,
    alignOffset,
    anchorRef,
    contentRef,
    viewportMargin,
  }: Omit<GetPositionArgs, "offset" | "side">,
) {
  if (!position) return null;
  const viewportHeight = window.innerHeight;
  const contentHeight = contentRef.current?.offsetHeight || 0;

  if (align === "end" && position.top < 0) {
    return { ...position, top: viewportMargin };
  }

  if (align === "start" && position.top + contentHeight > viewportHeight) {
    return {
      ...position,
      top: viewportHeight - contentHeight - viewportMargin,
    };
  }

  if (align === "center") {
    const targetRect = anchorRef.current?.getBoundingClientRect();
    if (!targetRect) return position;
    const centeredTop =
      targetRect.top + (targetRect.height - contentHeight) / 2 + alignOffset;
    if (centeredTop < 0) {
      return { ...position, top: viewportMargin };
    }
    if (centeredTop + contentHeight > viewportHeight) {
      return {
        ...position,
        top: viewportHeight - contentHeight - viewportMargin,
      };
    }
  }

  return position;
}
